import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API, api, fmtQty } from "../api";
import { Printer, ArrowLeft } from "lucide-react";

const PER_PAGE = 24;

export default function QRLabels({ mode }) {
  const { id } = useParams();
  const [boxes, setBoxes] = useState(null);

  useEffect(() => {
    document.body.classList.add("labels-print");
    return () => document.body.classList.remove("labels-print");
  }, []);

  useEffect(() => {
    if (mode === "box") {
      api.get(`/boxes/${id}`).then((r) => setBoxes([r.data])).catch(() => {});
    } else {
      api.get(`/boxes`, { params: { lot_id: id } }).then((r) => setBoxes(r.data)).catch(() => {});
    }
  }, [id, mode]);

  if (!boxes) return <div className="text-slate-500" data-testid="labels-loading">Loading labels...</div>;

  const pages = [];
  for (let i = 0; i < boxes.length; i += PER_PAGE) pages.push(boxes.slice(i, i + PER_PAGE));

  return (
    <div data-testid="qr-labels-page" className="space-y-4">
      <div className="flex gap-3 no-print">
        <Link to={mode === "box" ? `/boxes/${id}` : `/lots/${id}`} className="h-10 px-4 rounded-md border border-border inline-flex items-center gap-2 text-sm font-semibold text-[#002B5D] bg-white">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <a data-testid="print-labels-button" href={`${API}/labels.pdf?${mode === "box" ? `box_ids=${id}` : `lot_id=${id}`}`} download
          className="h-10 px-5 rounded-md font-heading font-bold text-sm text-white inline-flex items-center gap-2" style={{ backgroundColor: "#EB1C27" }}>
          <Printer className="w-4 h-4" /> Download {boxes.length} Label{boxes.length === 1 ? "" : "s"} PDF
        </a>
        <span className="text-sm text-slate-500 self-center">100mm × 44.4mm labels · 12 per A4 page</span>
      </div>

      {boxes.length === 0 && <div className="text-slate-400 text-sm">No boxes to print.</div>}

      {pages.map((pageBoxes, pi) => (
        <div key={pi} className="label-page bg-white mx-auto" data-testid={`label-page-${pi + 1}`}
          style={{ width: "196mm", display: "grid", gridTemplateColumns: "repeat(3, 64mm)", gridAutoRows: "34.5mm", gap: "2mm" }}>
          {pageBoxes.map((b) => (
            <div key={b.id} className="flex items-center overflow-hidden rounded-sm" data-testid={`label-${b.box_id}`}
              style={{ width: "64mm", height: "34.5mm", border: "0.3mm solid #002B5D", padding: "1.5mm" }}>
              <img src={`${API}/boxes/${b.id}/qr`} alt={b.box_id} style={{ width: "28mm", height: "28mm", flexShrink: 0 }} />
              <div style={{ marginLeft: "2mm", minWidth: 0, fontFamily: "'Inter', sans-serif" }}>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: "9pt", color: "#002B5D", lineHeight: 1.2 }}>{b.lot_number}</div>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: "9pt", color: "#EB1C27", lineHeight: 1.2 }}>{b.box_number}</div>
                <div style={{ fontSize: "7pt", color: "#333", marginTop: "1mm", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "30mm" }}>{b.product_name}</div>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "7pt", color: "#555" }}>Qty: {fmtQty(b.qty)} {b.uom}</div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
